module.exports = __webpack_public_path__ + "img/invitation_gift.f5cb4aeb.gif";